module.exports = __webpack_public_path__ + "img/Punta-del-este-2012.4e5b245c.jpg";